import styled from '@mui/material/styles/styled';
import List from '@mui/material/List';

export const StyledList = styled(List)(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  height: '100%',
  maxHeight: '500px',
  overflowY: 'auto',
  ...theme.scrollbars.paper,
}));